import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, of, throwError } from 'rxjs';

import { MessageService } from 'primeng/api';
import { appStateStore } from '@shared/stores/app-state.store';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  private readonly stateStore = inject(appStateStore);
  private readonly router: Router = inject(Router);
  private readonly messageService: MessageService = inject(MessageService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((httpError: HttpErrorResponse) => {
        const { error, message, status } = httpError;
        const errorMessage = error?.message || message;
        if (status === 400 || status === 404 || status === 403 || status === 500) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: errorMessage,
            closable: true,
          });
          return throwError(() => httpError);
        }
        if (status === 401 && !request.url.includes('core')) {
          this.logOutAndRedirect();
          return throwError(() => httpError);
        }
        return throwError(() => httpError);
      }),
    );
  }

  private logOutAndRedirect(): Observable<unknown> {
    this.stateStore.removeState();
    this.router.navigate(['/authorization']);
    return of(null);
  }
}
